export default class InvalidEmailError extends Error {
  constructor() {
    super("Invalid Email");
  }
}
